var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('common-btn',{class:['shareBtn', _vm.type],attrs:{"btnText":_vm.btnText,"tipsLeft":"50%","tipsText":_vm.tipsText,"hasTips":_vm.hasTips,"type":_vm.type,"shareDesc":_vm.shareDesc,"btnType":"share","registerAwardsType":_vm.registerAwardsType,"couponType":_vm.couponType},on:{"click":_vm.toShare}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }